module.exports = __webpack_public_path__ + "img/imageConfirmation.72a5076d.svg";